export default "__VITE_ASSET__BkwF6Srv__"